
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd3Grid extends Serenity.EntityGrid<PsAdvPromoHd3Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd3Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd3Dialog; }
        protected getIdProperty() { return PsAdvPromoHd3Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd3Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd3Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd3Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}